// extracted by mini-css-extract-plugin
export default {"dataAnalysesContainer":"styles_dataAnalysesContainer__bXxOt","title":"styles_title__zFleO","tabelaSinteseResultados":"styles_tabelaSinteseResultados__vo668"};